<template>
  <v-container fluid>
    <!-- <el-overlay-loading :loading="pageloading" /> -->
    <h3 class="mb-5">Rankinis duomenų įvedimas</h3>

    <v-data-table
      :headers="filteredHeaders"
      :items="itemsList"
      :loading="loading"
      :search="search"
      :footer-props="{
        showFirstLastPage: true,
        showCurrentPage: true,
        itemsPerPageText: 'Rodyti po:',
        itemsPerPageAllText: 'visi',
        itemsPerPageOptions: itemsPerPageOptions,
      }"
      :hide-default-footer="hideFooter"
      :page.sync="page"
      :items-per-page="pageSize"
    >
      <template #top>
        <v-toolbar flat>
          <v-text-field
            v-model="search"
            prepend-icon="mdi-magnify"
            label=""
            single-line
            hide-details
          ></v-text-field>
        </v-toolbar>
      </template>
      <template #[`item.krovimas`]="{ item }">
        <el-switch
          v-model="item.krovimas"
          @click.native="changeKrovimas(item)"
        />
      </template>
      <template #[`item.busena_text`]="{ item }">
        <el-busena :busena="item.busena_text" :color="item.busena_color" />
      </template>
      <template slot="loading">
        Kraunasi...
      </template>
      <template slot="no-results">
        Duomenų nėra
      </template>
      <template slot="no-data">
        Duomenų nėra
      </template>
      <template #[`footer.page-text`]="props">
        Rodoma {{ props.pageStart }}-{{ props.pageStop }} iš
        {{ props.itemsLength }}
      </template>
    </v-data-table>

    <modal-confirm
      title="Rankinis duomenų įvedimas"
      :text="confirmText"
      :item="confirmItem"
      action="Keitimas"
      v-model="showConfirm"
      @confirmKeitimas="saveData"
      @cancelConfirm="cancelData"
    />
  </v-container>
</template>

<script>
import print from '../../mixins/print'
import ModalConfirm from '../modals/ModalConfirm'

export default {
  name: 'AdminRegistrai',
  components: {
    ModalConfirm,
  },
  mixins: [print],
  data() {
    return {
      showConfirm: false,
      confirmText: null,
      confirmItem: null,
      pageloading: true,
      loading: true,
      formData: [],
      search: null,
      itemsPerPageOptions: [10, 50, -1],
      pageSize: 10,
      page: 1,
    }
  },
  computed: {
    headers() {
      return [
        {
          text: 'Veiksmai',
          align: 'center',
          value: 'krovimas',
          width: 100,
        },
        {
          text: 'Registro pavadinimas',
          align: 'start',
          sortable: true,
          value: 'trs_pavadinimas',
        },
        {
          text: 'Būsena',
          align: 'start',
          sortable: true,
          value: 'busena_text',
        },
        {
          text: 'Būsenos data',
          align: 'start',
          sortable: true,
          value: 'trs_atnaujinimo_data',
        },
        {
          text: 'Būseną pakeitęs asmuo',
          align: 'start',
          sortable: true,
          value: 'busena_pakeite',
        },
      ]
    },
    filteredHeaders() {
      return this.headers.filter(item => {
        return !item.hide
      })
    },
    itemsList() {
      return this.formData.map((item, index) => {
        item.busena_text = item.busena
          ? 'Krovimas įjungtas'
          : 'Krovimas išjungtas'
        item.busena_color = item.busena ? 'green' : 'default'
        return item
      })
    },
    hideFooter() {
      return this.itemsList.length <= 10
    },
    isLocal() {
      return process.env.VUE_APP_LOCAL === 'local'
    },
  },
  created() {
    this.getData()
  },
  methods: {
    getData() {
      this.pageloading = true
      this.loading = true

      this.$axios
        .get(`admin/turtasrusis`)
        .then(res => {
          this.formData = res.data.rusys
        })
        .catch(err => {
          window._VMA.$emit('DATA_ERROR', err.response.data.message)
        })
        .finally(() => {
          this.loading = false
          this.pageloading = false
        })
    },
    saveData(item) {
      this.loading = true

      let data = {
        trs_id: item.trs_id,
        krovimas: item.krovimas,
      }

      this.$axios
        .post(`admin/turtasrusis/${item.trs_id}`, data)
        .then(res => {
          window._VMA.$emit('DATA_OK', res.data.message)
          this.getData()
        })
        .catch(err => {
          window._VMA.$emit('DATA_ERROR', err.response.data.message)
        })
        .finally(() => {
          this.loading = false
        })
    },
    changeKrovimas(item) {
      this.confirmText = `Ar norite ${
        item.krovimas ? 'įjungti' : 'išjungti'
      } registro <b>${item.trs_pavadinimas}</b> užkrovimą?`
      this.confirmItem = item
      this.showConfirm = true
    },
    cancelData(item) {
      item.krovimas = !item.krovimas
      this.showConfirm = false
    },
  },
}
</script>
